/**
 * The Server's own explanation of a rejection, when it sent one.
 *
 * Axios turns every non-2xx into `Error("Request failed with status code 409")`,
 * which tells a user nothing and hides a sentence the Server wrote for them —
 * "someone else changed these rates, reload and reapply" becomes "Save failed".
 *
 * Only worth reaching for where the Server writes its rejections as sentences
 * meant for a person. A caller that cannot say what went wrong should keep its
 * own copy rather than relay whatever the Server happened to say.
 */
export function serverErrorMessage(error: unknown): string | undefined {
  if (typeof error !== "object" || error === null || !("response" in error)) {
    return undefined;
  }
  const message = (error as { response?: { data?: { error?: unknown } } })
    .response?.data?.error;
  return typeof message === "string" && message.trim().length > 0
    ? message
    : undefined;
}

/** The Server's sentence if there is one, else whatever the transport said. */
export function failureReason(error: unknown, fallback: string): string {
  return (
    serverErrorMessage(error) ??
    (error instanceof Error ? error.message : fallback)
  );
}
